import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-customer-survey-rating',
  templateUrl: './customer-survey-rating.component.html',
  styleUrls: ['./customer-survey-rating.component.scss']
})
export class CustomerSurveyRatingComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;

  @Input() starId;
  @Input() rating;

  @Output() starEnter = new EventEmitter<number>();
  @Output() starLeave = new EventEmitter<number>();
  @Output() starClicked = new EventEmitter<number>();

  detail: { [unit: string]: any } = {};
  data: any = {};

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    this.detail = this.data;
  }

  onStarEnter() {
    //Start Enter
  }
  onStarLeave() {
    //Start Leave
  }
  onStarClicked() {
    //Start Click
  }

}
